import { FieldErrors } from 'react-hook-form';

/// A mensagem do primeiro campo inválido, inclusive dentro de listas e objetos (`options.0.value`).
export const firstErrorMessage = (errors: FieldErrors | undefined): string | undefined => {
    if (!errors || typeof errors !== 'object') return undefined;

    const own = (errors as { message?: unknown }).message;
    if (typeof own === 'string' && own) return own;

    for (const [key, child] of Object.entries(errors)) {
        // `ref` é o elemento do campo, não um erro: descer nele percorre o DOM.
        if (key === 'ref' || !child || typeof child !== 'object') continue;

        const message = firstErrorMessage(child as FieldErrors);
        if (message) return message;
    }

    return undefined;
};
